import Swal from "sweetalert2";
import { utils, writeFile } from "xlsx";
import messages from "../constants/messages";

export const handleDownloadExcel = (data, fileName) => {
  console.log("data", data);
  if (!data || data.length === 0) {
    Swal.fire({
      title: messages.titles.warning,
      text: "There is no data to export",
      icon: "warning",
      confirmButtonText: messages.buttons.ok,
    });
  } else {
    const ws = utils.json_to_sheet(data);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Sheet1");
    writeFile(wb, `${fileName}.xlsx`);
  }
};
